import React, { Component } from 'react';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;

class ModalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <Modal
        title="账户信息"
        visible
        onOk={this.submit}
        onCancel={() => this.props.onCancel(false)}
      >
        <Form>
          <FormItem label="户名" {...formItemLayout}>
            {getFieldDecorator('accountName', {
              rules: [{ required: true, message: '请输入账户名称' }],
              initialValue: data.accountName,
            })(<Input />)}
          </FormItem>
          <FormItem label="银行账号" {...formItemLayout}>
            {getFieldDecorator('account', {
              initialValue: data.account,
            })(<Input />)}
          </FormItem>
          <FormItem label="税号" {...formItemLayout}>
            {getFieldDecorator('taxCode', {
              initialValue: data.taxCode,
            })(<Input />)}
          </FormItem>
          <FormItem label="开户行" {...formItemLayout}>
            {getFieldDecorator('accountBank', {
              initialValue: data.accountBank,
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/ModalAccount.js